import { classNames } from "./Utils/classNames.ts";

const sizeClassNames = {
  sm: { group: "text-xs", option: "px-2.5 py-1" },
  md: { group: "text-sm", option: "px-3 py-[7px]" },
};

export function SegmentedControl<Value extends string | number>({
  options,
  value,
  onChange,
  size = "sm",
}: {
  options: { value: Value; label: string }[];
  value: Value;
  onChange: (value: Value) => void;
  size?: keyof typeof sizeClassNames;
}) {
  return (
    <div
      role={"group"}
      className={classNames(
        "inline-flex rounded-lg border border-slate-200 bg-white p-0.5",
        sizeClassNames[size].group,
      )}
    >
      {options.map((option) => (
        <button
          key={option.value}
          type={"button"}
          aria-pressed={option.value === value}
          onClick={() => onChange(option.value)}
          className={classNames(
            "rounded-md whitespace-nowrap transition-colors",
            sizeClassNames[size].option,
            option.value === value
              ? "bg-slate-100 text-slate-800 font-semibold"
              : "text-slate-500 hover:text-slate-700",
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
